import React, { useState } from 'react';
import { FormControl, MenuItem, Select } from '@material-ui/core';

import lang from '../../../lib/language';

import ArrowDown from '../../../assets/img/icon_expan_down_ratios.svg';
import ClearIcon from '../../../assets/img/icon-clear.svg';
import { ClickableDiv, ClickableImage, MobileDrawer } from '../../../components';
import { useBrowserWidth, useIsMobile } from '../../../hooks';
import { ZOOM_BEHAVIOR_WIDTH } from '../../../util/constants';
import { useStyles } from '../TradeHistoryStyles';

import styles from './StatusSelector.module.scss';

type Props = {
    currentStatus: string;
    handleChangeByStatus: (event: React.ChangeEvent<{ value: unknown }> | string) => void;
    handleBtnClose: any;
    statusList: string[];
    handleMenuItem: (item: string) => JSX.Element;
    handleReset: () => void;
}

const StatusSelector = (props: Props) => {
  const { currentStatus, handleChangeByStatus, handleBtnClose, statusList, handleMenuItem, handleReset } = props;
  const { browserWidthSize } = useBrowserWidth();
  const classes = useStyles();
  const { isMobile } = useIsMobile();

  const [isOpenStatusField, setIsOpenStatusField] = useState<boolean>(false);
  const [showClearButton, setShowClearButton] = useState<boolean>(false);

  const handleOnOpen = () => {
    setIsOpenStatusField(true);
  };

  const handleOnClose = () => {
    setIsOpenStatusField(false);
  };

  const handleChange = (status: string) => {
    handleChangeByStatus(status);
    setIsOpenStatusField(false);
    setShowClearButton(true);
  };

  const onButtonClose = () => {
    handleReset();
    setShowClearButton(false);
  };

  return (
    <>
      { isMobile ? (
        <>
          <div className={showClearButton ? styles.statusWrapperSelected : styles.statusWrapper}>
            <ClickableDiv className={styles.statusContainer} onClick={handleOnOpen}>
              <div className={styles.status}>
                {currentStatus}
              </div>
            </ClickableDiv>
            {showClearButton ? (
              <ClickableImage
                className={styles.actionButton}
                src={ClearIcon}
                alt="clear"
                onClick={onButtonClose}
              />
            ) : (
              <img src={ArrowDown} alt="arrow" className={styles.actionButton} />
            )}
          </div>
          <MobileDrawer
            isOpen={isOpenStatusField}
            title={lang.commonOrderStatusFilterTitle()}
            onClose={handleOnClose}
            usePortal
          >
            <div className={styles.orderTypes}>
              {statusList.slice(1).map((status) => (
                <button
                  key={status}
                  type="button"
                  className={styles.orderType}
                  onClick={() => { handleChange(status); }}
                >
                  {status}
                </button>
              ))}
            </div>
          </MobileDrawer>
        </>
      ) : (
        <FormControl classes={{ root: classes.formControl }}>
          <Select
            value={currentStatus}
            disableUnderline
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              PaperProps: {
                style: {
                  backgroundColor: '#191C2E',
                  color: '#FFFFFF',
                  borderRadius: 12,
                  marginLeft: browserWidthSize <= 400 ? '10%' : '',
                  zoom: browserWidthSize <= ZOOM_BEHAVIOR_WIDTH ? `${Math.floor(browserWidthSize / 10).toString()}%` : '',
                },
              },
              getContentAnchorEl: null,
            }}
            classes={{
              select: (currentStatus === lang.commonOrderStatusFilterTitle() && !isOpenStatusField)
                ? classes.initialSelect
                : classes.activeSelect,
            }}
            onOpen={handleOnOpen}
            onClose={handleOnClose}
            onChange={handleChangeByStatus}
            IconComponent={handleBtnClose}
          >
            {statusList.map((item) => (
              <MenuItem
                key={item}
                value={item}
                classes={{
                  root: classes.menuItemRoot,
                  selected: classes.selected,
                }}
              >
                {handleMenuItem(item)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
};

export default StatusSelector;
